var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        width: "600px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "100px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "页面类型", prop: "pageType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择页面类型" },
                  model: {
                    value: _vm.form.pageType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "pageType", $$v)
                    },
                    expression: "form.pageType",
                  },
                },
                _vm._l(_vm.pageTypeEnum, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "分享文案", prop: "shareText" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  maxlength: "100",
                  "show-word-limit": "",
                  placeholder: "请输入分享文案",
                  resize: "none",
                },
                model: {
                  value: _vm.form.shareText,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "shareText", $$v)
                  },
                  expression: "form.shareText",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "share-tip" },
                [
                  _c("i", {
                    staticClass: "el-icon-magic-stick share-tip__icon",
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "share-tip__text" }, [
                    _vm._v("点击可引用至文本框中"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "share-tip__divider" }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "share-tip__chip",
                      attrs: { type: "text", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.insertPlaceholder("小程序名称")
                        },
                      },
                    },
                    [
                      _c("span", [
                        _c("span", { staticStyle: { color: "blue" } }, [
                          _vm._v("<>"),
                        ]),
                        _vm._v(" 小程序名称"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.form.pageType === 4
                    ? _c(
                        "el-button",
                        {
                          staticClass: "share-tip__chip",
                          attrs: { type: "text", size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.insertPlaceholder("装修页名称")
                            },
                          },
                        },
                        [
                          _c("span", [
                            _c("span", { staticStyle: { color: "blue" } }, [
                              _vm._v("<>"),
                            ]),
                            _vm._v(" 装修页名称"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showProductName
                    ? _c(
                        "el-button",
                        {
                          staticClass: "share-tip__chip",
                          attrs: { type: "text", size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.insertPlaceholder("商品名称")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-goods" }),
                          _vm._v(" "),
                          _c("span", [
                            _c("span", { staticStyle: { color: "blue" } }, [
                              _vm._v("<>"),
                            ]),
                            _vm._v(" 商品名称"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "封面图", prop: "coverImage" } },
            [
              _c("div", { staticClass: "upload-row" }, [
                _c(
                  "div",
                  {
                    staticClass: "upLoadPicBox",
                    on: { click: _vm.modalPicTap },
                  },
                  [
                    _vm.form.coverImage
                      ? _c("div", { staticClass: "pictrue" }, [
                          _c("img", { attrs: { src: _vm.form.coverImage } }),
                        ])
                      : _c("div", { staticClass: "upLoad" }, [
                          _c("i", {
                            staticClass: "el-icon-camera cameraIconfont",
                          }),
                        ]),
                  ]
                ),
                _vm._v(" "),
                _vm.form.coverImage
                  ? _c("i", {
                      staticClass: "el-icon-delete remove-icon",
                      on: { click: _vm.removeCoverImg },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-tip" }, [
                _vm._v("支持上传png/jpg的图片格式，上传大小≤200KB"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "关联小程序", prop: "appScope" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.appScope,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "appScope", $$v)
                    },
                    expression: "form.appScope",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("全部")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("部分")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.appScope === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "选择小程序", prop: "appIds" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { multiple: "", placeholder: "请选择小程序" },
                      model: {
                        value: _vm.form.appIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "appIds", $$v)
                        },
                        expression: "form.appIds",
                      },
                    },
                    _vm._l(_vm.appOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "status" } },
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "开启后以上配置内容生效",
                        placement: "top",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-question",
                        staticStyle: { "margin-left": "4px" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("状态")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-switch", {
                attrs: {
                  "active-value": 1,
                  "inactive-value": 0,
                  "active-text": "开启",
                  "inactive-text": "禁用",
                },
                model: {
                  value: _vm.form.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "status", $$v)
                  },
                  expression: "form.status",
                },
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }